<template>
	<div class="plans-list">
		<HeadingSVG imgName="buy-insurance" altText="Buy Insurance" />
		<div class="tab-head-list">
			<FlipButton
				v-for="(plan, index) in plans"
				:key="plan.id"
				class="tab-head"
				:active="index === activeIndex"
				:action="() => select(index)"
			>
				{{ plan.title }}
			</FlipButton>
		</div>
		<InsurancePlan v-bind="activePlan" />
		<MarqueeButton :action="advance" :disabled="unaffordable">
			{{ ui.continue_button }}
		</MarqueeButton>
		<router-link to="/game/shop/plans/compare" class="simple-link" @click.native="soundEffect">
			{{ ui.table_view_link }}
		</router-link>
	</div>
</template>


<script>
import FlipButton from '@/components/base/FlipButton';
import HeadingSVG from '@/components/base/HeadingSVG';
import MarqueeButton from '@/components/base/MarqueeButton';
import InsurancePlan from '@/components/game/shop/plan/InsurancePlan';
import { mapState, mapGetters } from "vuex";

export default {
	name: 'PlansList',
	components: {
		FlipButton,
		HeadingSVG,
		MarqueeButton,
		InsurancePlan,
	},
	computed: {
		...mapState({
			selectedId: (state) => state.game.plans.selectedID,
			ui: (state) => state.global.api.data.ui.plans,
		}),
		...mapGetters({
			plans: "game/plans/available",
			cost: "game/plans/selected/totalCost",
		}),
		unaffordable() {
			return this.$store.state.game.plans.selected
				&& this.$store.state.game.balance.amount < this.cost;
		},
		activePlan() {
			return this.plans[this.activeIndex];
		},
	},
	data: () => ({
		activeIndex: 0,
	}),
	methods: {
		async select(index) {
			if (index !== this.activeIndex) {
				this.$store.dispatch("sound/fx/play", { id: "select_plan" });
			}
			this.activeIndex = index;
			await this.$store.dispatch("game/plans/select", this.plans[this.activeIndex]);
		},
		advance() {
			this.$router.push(`/game/shop/plans/addons`);
			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
		},
		soundEffect() {
			this.$store.dispatch("sound/fx/play", { id: "whoosh_generic" });
		},
	},
	created() {
		this.activeIndex = this.plans.findIndex(({ id }) => id === this.selectedId);
	},
};
</script>

<style lang="scss" scoped>
	.plans-list { margin-bottom: $page-bottom-spacing; }
	.simple-link {
		display: none;
		color: $primary-color-light;

		@include desktop { display: inline; }
	}

	.tab-head-list {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-evenly;
		align-items: center;
		margin: 0 20px 20px;
		font-family: $heading-font;
		font-size: $font-size-md;
		letter-spacing: $letter-spacing-plus;
		max-width: 425px;

		@include tablet { max-width: 550px; }

		@include desktop {
			margin: 20px;
			max-width: unset;
		}
	}

	.tab-head {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0;
	}
</style>
